module.exports = __webpack_public_path__ + "images/emoji/crying_cat_face.27ab0454f241b876793f.png";